
import HeartRemove from "../../../assets/duotone/HeartRemove.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HeartRemoveIcon({ className, dataTestid = "HeartRemoveIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <HeartRemove data-testid={dataTestid} className={classes} {...rest} />
  );
}
